export enum ModelTypeParameter {
  All = 'ALL',
  BaseModel = 'BASE_MODEL',
  CustomModel = 'CUSTOM_MODEL'
}